<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'gruposCrud'"
          crudName="Grupos"
          newText="Novo Grupo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
          <div slot="unidade" slot-scope="props">
            {{ props.row.unidade ? props.row.unidade.nome : "-" }}
          </div>
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "gruposTable",
      gruposCrud: {},
      pages: [],
      url: "",
      columns: ["id", "nome", "unidade", "actions"],
      tableData: ["id", "nome", "unidade"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["nome", "unidade"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Nome",
          unidade: "Unidade",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          unidade: [],
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["unidade"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "grupos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
        unidade: "unidade_id",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.options.listColumns.unidade = (response.data.data || []).map(
            (unidade) => ({ id: unidade.id, text: unidade.nome })
          );
        })
        .catch(() => {});
    },
  },
  mounted: function () {
    this.getUnidades();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
